// src/api/TechLibraryApi.js
import api from "@/axios";

export default {
  getAll() {
    return api.get("/techlibrary");
  },
  getById(libSeq) {
    return api.get(`/techlibrary/${libSeq}`);
  },
  create(data) {
    return api.post("/techlibrary", data);
  },
  update(libSeq, data) {
    return api.put(`/techlibrary/${libSeq}`, data);
  },
  delete(libSeq) {
    return api.delete(`/techlibrary/${libSeq}`);
  }
};

/*
import axios from "axios";

const API_URL = "/api/techlibrary";
const vToken = `Bearer ${sessionStorage.getItem('token')}`;

export default {
  getAll() {
    return axios.get(API_URL, {
          headers: {
            Authorization: vToken
          }
        });
  },
  getById(libSeq) {
    return axios.get(`${API_URL}/${libSeq}`);
  },
  create(data) {
    return axios.post(API_URL, data);
  },
  update(libSeq, data) {
    return axios.put(`${API_URL}/${libSeq}`, data);
  },
  delete(libSeq) {
    return axios.delete(`${API_URL}/${libSeq}`);
  }
};
*/

